import { Stack, useTheme } from "@mui/material";
import { useQuestionnaireListContext } from "./context/useQuestionnaireList";

export const ScoresSection = () => {
    const theme = useTheme();
    const { hasScoresToDisplay, scoresSection } = useQuestionnaireListContext();

    if (hasScoresToDisplay === false || !scoresSection) {
        return null;
    }

    return (
        <Stack
            position={{ xs: "static", lg: "sticky" }}
            top={{ xs: "auto", lg: theme.spacing(3.5) }}
            marginTop={{ xs: theme.spacing(3), lg: 0 }}
            width={{ xs: "100%", lg: "25%" }}
            flex={{ xs: undefined, lg: 2 }}
            // flex={shouldShrink ? undefined : 2}
            sx={{
                height: "fit-content",
                minWidth: "326px",
                // position: shouldShrink ? "static" : "sticky",
                // top: shouldShrink ? "auto" : "28px",
                // marginTop: shouldShrink ? "24px" : "0px",
                // width: { lg: "25%", xs: "100%" },
            }}
        >
            {scoresSection}
        </Stack>
    );
};
